import store from '@/store';
import commonstate from '../constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from "../request_util";
export default {
    addCloudData(ud, n, k, p, domn, serv, prvk, bn, dt, cs, pt, redirectUrl) {
        this.ud = ud;
        this.n = n;
        if (k) {
            this.k = k;
        }
        if (p) {
            this.p = p;
        }
        if (domn) {
            this.domn = domn;
        }
        if (serv) {
            this.serv = serv;
        }
        if (prvk) {
            this.prvk = prvk;
        }
        if (bn) {
            this.bn = bn;
        }
        this.dt = dt;
        if (cs) {
            this.cs = cs;
        }
        if (pt) {
            this.pt = pt;
        }
        if (redirectUrl) {
            this.redirectUrl = redirectUrl;
        }
    },
    reWriteCloudData(ud, id, n, k, p, domn, serv, prvk, bn, dt, cs, pt, redirectUrl) {
        this.ud = ud;
        this.id = id;
        this.n = n;
        if (k) {
            this.k = k;
        }
        if (p) {
            this.p = p;
        }
        if (domn) {
            this.domn = domn;
        }
        if (serv) {
            this.serv = serv;
        }
        if (prvk) {
            this.prvk = prvk;
        }
        if (bn) {
            this.bn = bn;
        }
        this.dt = dt;
        if (cs) {
            this.cs = cs;
        }
        if (pt) {
            this.pt = pt;
        }
        
        if (redirectUrl) {
            this.redirectUrl = redirectUrl;
        }
    },
    getData(ud,id){
        this.ud = ud;
        this.id = id;
    },
    renameDrive(ud,id,n){
        this.ud=ud;
        this.id=id;
        this.n=n;
    },
    deleteDrive(ud,id){
        this.ud = ud;
        this.id = id;
    },//封装路径数据
    pushPath(sourceAimData) {
        let pathJson = [];
        pathJson.push({
            id: sourceAimData.rootId,
            name: sourceAimData.name,
            driveId: sourceAimData.id
        });
        let JsonList = Object.assign([], pathJson);
        store.commit("setPathJson", {
            folderId: sourceAimData.rootId + sourceAimData.id,
            json: JsonList
        });
    },//选中左侧的云盘项目
    selectLeftOption(sourceData, direction) {
        let dom;
        $.each(direction.$parent.$parent.$children, function(i, item) {
            if (item.menuOptions) {
                dom = direction.$parent.$parent.$children[i];
                return;
            }
        });
        if(direction.$route.name == 'addCloudEmail') {
            dom = direction.$parent.$parent.$parent.$refs.leftBanner;
        }
        let clouds = commonUtils.sortDriveName(dom.clouds);//进行排序是防止编辑后，选项混乱
        store.commit("setUsersDrives", clouds);
        $.each(clouds, function(i, item) {
            if (sourceData.id == item.id) {
                dom.addDriveSelect(item.id, item, false);
                return false;
            }
        });
    },
    //把该返回的云盘数据存入云盘缓存进行封装
    putDriveToCategories(drive,flag,direction){
        let that=this;
        let packageDrive;
        let leftBanner;
        let fromEmail = false;
        if(direction.$route.name == 'emailTransfer') {
            leftBanner = direction.$parent.$parent.$parent.$parent.$refs.leftBanner;
            fromEmail = true;
        }if(direction.$route.name == 'addCloudEmail') {
            leftBanner = direction.$parent.$parent.$parent.$refs.leftBanner;
        }else{
            leftBanner = direction.$parent.$parent.$refs.leftBanner;
        }
        
        var allClouds = leftBanner.clouds;
        
        for (let index = 0; index < allClouds.length; index++) {
            const element = allClouds[index];
           if(element.id == drive.id){
               if(!fromEmail){
                   that.selectLeftOption(element, direction);
               }else{
                    direction.$parent.$parent.close();
               }
            direction.$toast({
                text: direction.$t('language.exception.alreadyAdd'),
                type: 'fail',
                idValue: "rightContBan"
            });
            flag = false;
            return;
           }
        }
        $.each(commonstate.cloudCategories, function (j, category) {//把该返回的云盘数据存入缓存进行封装
            if (drive.categoryId == category.id && category.level > 0) {
                packageDrive = {
                    appName: category.appName,
                    categoryInfo: category,
                    keyId: drive.id + drive.rootId,
                    driveType: category.appName,
                    name: drive.name,
                    id: drive.id,
                    rootId: drive.rootId,
                    methods: category.methods,
                    driveInfo: drive
                };
                store.commit("setCatalogFileId", drive.id);
                leftBanner.clouds.push(packageDrive);
                leftBanner.clouds= commonUtils.sortDriveName(leftBanner.clouds);
                store.commit("setUsersDrives", leftBanner.clouds);
                that.pushPath(drive);
                if(!fromEmail){
                    that.selectLeftOption(drive, direction);
                }else{
                    direction.$parent.$parent.close();
                }
                flag = false;
                return;
            }
        });
    },
    //把编辑过的云盘数据存入云盘缓存进行封装
    editStoreDrive(drive,direction){
        let allClouds = direction.$parent.$parent.$refs.leftBanner.clouds;
        $.each(allClouds, function (i, cloud) {
            if (cloud.id == direction.cloudId) {
                //如果发生id更改，此处也需要更改
                cloud.id = drive.id;
                cloud.keyId = drive.id + drive.rootId;
                cloud.name = drive.name;
                cloud.driveInfo = drive;
                if(cloud.rootId ){
                    cloud.rootId=drive.rootId;
                }
                return false;
            }
        });
        allClouds = commonUtils.sortDriveName(direction.$parent.$parent.$refs.leftBanner.clouds);
        store.commit("setUsersDrives", allClouds);
        store.commit("setCatalogFileId", drive.id);
        this.pushPath(drive);
        this.selectLeftOption(drive, direction);
    },
    //把编辑过的云盘数据存入云盘缓存进行封装
    editCloudByRestore(drive,direction){
        let allClouds = direction.$parent.$parent.$parent.$parent.$parent.$refs.leftBanner.clouds;
        $.each(allClouds, function (i, cloud) {
            if (cloud.id == direction.cloudId) {
                //如果发生id更改，此处也需要更改
                cloud.id = drive.id;
                cloud.keyId = drive.id + drive.rootId;
                cloud.name = drive.name;
                cloud.driveInfo = drive;
                if(cloud.rootId ){
                    cloud.rootId=drive.rootId;
                }
                return false;
            }
        });
        allClouds = commonUtils.sortDriveName(direction.$parent.$parent.$parent.$parent.$parent.$refs.leftBanner.clouds);
        store.commit("setUsersDrives", allClouds);
        store.commit("setCatalogFileId", drive.id);
    },
     //打开界面之前就给div高度
     getContainerHeight(direction) {
        // 自适应布局的添加弹窗没有固定高度的提示容器。
        if (!direction.$refs.container) return;
        let heightValue = parseInt(direction.$refs.container.innerText.length / 6);
        direction.$refs.container.style.height = heightValue + 'Px';
        let bigHeight;
        if(direction.$refs.addCloud){
        bigHeight= direction.$refs.addCloud.clientHeight;
        }else{
        bigHeight= direction.$refs.editCloud.clientHeight;
        }
        if (heightValue > 72) {//如果文字过多过长
            direction.boxHeight = bigHeight + heightValue + 20 + 'Px';
            if (direction.cloudName == 'gSuite') {//如果是gSuite云盘
                if (commonstate.cLanguageArr.includes(direction.$i18n.locale)) {//如果是日语，中文，繁体中文
                    direction.boxHeight = bigHeight + heightValue + 70 + 'Px';
                } else {//如果是除日语，中文，繁体中文以外的语言
                    direction.boxHeight = bigHeight + heightValue + 50 + 'Px';
                }
            }
            if (direction.cloudName == 'mySQL') {//如果是mysql云盘
                direction.boxHeight = bigHeight + heightValue - 30 + 'Px';
            }
            if (direction.cloudName == 'googlePhotos') {//如果是谷歌相册
                if (commonstate.cLanguageArr.includes(direction.$i18n.locale)) {//如果是日语，中文，繁体中文
                    direction.boxHeight = bigHeight + heightValue + 120 + 'Px';
                } else if (direction.$i18n.locale == 'english') {//如果是英语
                    direction.boxHeight = bigHeight + heightValue - 20 + 'Px';
                } else {//如果是除以上的其他语言
                    direction.boxHeight = bigHeight + heightValue + 50 + 'Px';
                }
            }
        } else {
            if (direction.cloudName == 'hubiC') {//如果是hubic云盘
                direction.boxHeight = bigHeight + heightValue - 25 + 'Px';
            } else if (direction.cloudName == 'backblaze') {//如果是backblaze
                direction.boxHeight = 445 + 'Px';
            } else if (direction.cloudName == 'evernote') {//如果是evernote
                direction.boxHeight = bigHeight + heightValue - 10 + 'Px';
            } else if (direction.cloudName == 'webDav') {//如果是webDav
                direction.boxHeight = bigHeight + heightValue + 'Px';
            } else if (direction.cloudName == 'gSuite') {//如果是gSuite
                direction.boxHeight = bigHeight + heightValue + 50 + 'Px';
            } else if (direction.cloudName == 'mySQL') {//如果是mySQL
                direction.boxHeight = bigHeight + heightValue + 5 + 'Px';
            } else if (direction.cloudName == 'googlePhotos') {//如果是mySQL的中文，heightValue等于72
                direction.boxHeight = bigHeight + heightValue + 40 + 'Px';
            } else {
                direction.boxHeight = 0 + 'Px';//其他云盘高度为最小的高度315PX;
            }
        }
        if (direction.cloudName == 'flickr') {//如果是flickr云盘
            direction.boxHeight = bigHeight + heightValue + 'Px';
            if (direction.$i18n.locale == 'japanese') {
                direction.boxHeight = bigHeight + heightValue + 20 + 'Px';
            }
        }
        if (direction.specialTipsCloud.includes(direction.cloudName)) {
            direction.boxHeight = bigHeight + heightValue + 35 + 'Px';
            if (direction.$i18n.locale == 'japanese') {
                direction.boxHeight = bigHeight + heightValue + 45 + 'Px';
            }
        }
    },//编辑时打开ftp详情
    openFtpInfo(ftpInfo,direction){
        direction.$refs.editFtpDialog.httpName = ftpInfo.server.substring(0, ftpInfo.server.lastIndexOf(':'));
        if (ftpInfo.server.indexOf('?') != -1) {
            direction.$refs.editFtpDialog.port = ftpInfo.server.substring(ftpInfo.server.lastIndexOf(':') + 1, ftpInfo.server.indexOf('?'));
        } else {
            direction.$refs.editFtpDialog.port = ftpInfo.server.substring(ftpInfo.server.lastIndexOf(':') + 1, ftpInfo.server.length);
        }
        if (ftpInfo.username) {
            direction.$refs.editFtpDialog.email = ftpInfo.username;
        } else {
            direction.$refs.editFtpDialog.email = ftpInfo.email;
        }
    },//编辑时打开Nas详情
    openNasInfo(nasInfo,direction){
        direction.$refs.editNasDialog.editNasShow = true;
        let tab1Page = direction.$refs.editNasDialog.$refs.viaFtp;
        let tab2Page = direction.$refs.editNasDialog.$refs.viaWebDav;
        direction.$refs.editNasDialog.cloudId = nasInfo.id;
        if (nasInfo.server.indexOf('ftp://') != -1) {
            direction.$refs.editNasDialog.activeName = 'first';
            tab1Page.httpName = nasInfo.server.substring(0, nasInfo.server.lastIndexOf(':'));
            if (nasInfo.server.lastIndexOf('?') != -1) {
                tab1Page.port = nasInfo.server.substring(nasInfo.server.lastIndexOf(':') + 1, nasInfo.server.lastIndexOf('?'));
            } else {
                tab1Page.port = nasInfo.server.substring(nasInfo.server.lastIndexOf(':') + 1, nasInfo.server.length);
            }
            tab1Page.email = nasInfo.username;
            tab1Page.displayName = nasInfo.name;
        } else {
            tab2Page.webDavserverHttp = nasInfo.server.substring(0, nasInfo.server.lastIndexOf(':'));
            if (nasInfo.server.lastIndexOf('?') != -1) {
                tab2Page.portNumber = nasInfo.server.substring(nasInfo.server.lastIndexOf(':') + 1, nasInfo.server.lastIndexOf('?'));
            } else {
                tab2Page.portNumber = nasInfo.server.substring(nasInfo.server.lastIndexOf(':') + 1, nasInfo.server.length);
            }
            direction.$refs.editNasDialog.activeName = 'second'
            tab2Page.username = nasInfo.username;
            tab2Page.displayName = nasInfo.name;
        }
    },
    openProperties(direction,totalSpace,usedSpace){
        direction.$refs.propertiesDialog.proDialogShow = true;
        direction.$refs.propertiesDialog.activeName = "first";
        direction.$refs.propertiesDialog.unTips = commonstate.unTips;
        let emailpattern=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if(direction.selectItem.driveInfo.authKey&&emailpattern.test(direction.selectItem.driveInfo.authKey)){
        direction.$refs.propertiesDialog.userName = direction.selectItem.driveInfo.authKey;
        }else if(direction.selectItem.driveInfo.username){
            direction.$refs.propertiesDialog.userName=direction.selectItem.driveInfo.username;
        }else if(direction.selectItem.driveInfo.email){
            direction.$refs.propertiesDialog.userName=direction.selectItem.driveInfo.email;
        }else{
            direction.$refs.propertiesDialog.userName = commonUtils.getUser().username;
        }
        direction.$refs.propertiesDialog.driveType=direction.selectItem.appName;
        direction.$refs.propertiesDialog.totalSpace=totalSpace;
        direction.$refs.propertiesDialog.usedSpace=usedSpace;
        direction.cloudName = direction.selectItem.appName;
        direction.cloudId = direction.selectItem.id;
        direction.cloud = direction.selectItem;
    },
    //删除云盘
    deletePage(cloudId,direction) {
            let deleteData=new this.deleteDrive(commonUtils.getUser().id,cloudId);
            requestUtils.doDrivesRequest("delete", deleteData).then(res => {
                if (res.status == 200) {
                    //删除云盘成功
                    direction.deleCloudSuccess();
                } else {
                    direction.$toast({
                        text: direction.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "leftBan"
                    });
                }
            });
        },

}



// WEBPACK FOOTER //
// ./src/js/workspace/add_cloud_utils.js